import React from "react";
import { useNavigate, Link } from 'react-router-dom';
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";
import Footer from "../Component/Footer";
import SubMenu from "../Component/SubMenu";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';

import mainBg from "../../assets/img/bg-busuness-02.jpg";
import busi05 from "../../assets/img/business-05.jpg";
import busi06 from "../../assets/img/business-06.jpg";
import busi07 from "../../assets/img/business-07.jpg";
import busi08 from "../../assets/img/business-08.jpg";
import CallWipia from "./CallWipia";

function BusinessArea() {
    // 화면 이동을 위한 네비게이터 설정
	const navigate = useNavigate();

	// 일반 또는 관리자 header 설정
	const { argInfo } = useContext(ArgContext);
	const isAdmin = argInfo?.role === 'admin';

    return (<>
	<main className="page-wrapper">
		{isAdmin ? <AdminHeader /> : <Header />}
        {/* <!-- 메인 미이지 + 슬로건 --> */}
			<section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
					<div className="textBox">
						<h2>System Integration</h2>
						<p>위피아는 고객의 사업목표를 효과적으로 지원할 수 있도록 웹 및 모바일 통합 IT 서비스를 제공합니다.</p>
					</div>
					<SubMenu />
			</section>

			<section className="container-auto sec-my bs-consulting-wrap">
					<ul className="consulting-list">
						{/* <!-- Item 01 --> */}
						<li>
							<img src={busi05} alt="Analyze" />

							<div className="textBox">
								<h4 className="title"><span className="num">01</span> Analyze</h4>
								<p className="text">고객이 원하는 Needs에 부합한 시스템 개발을 위해서 철저한 분석과 설계에 최선을 다합니다.</p>
							</div>
						</li>

						{/* <!-- Item 02 --> */}
						<li>

							<img src={busi06} alt="Development" />
							<div className="textBox">
								<h4 className="title"><span className="num">02</span> Development</h4>
								<p className="text">각 분야별 전문적인 인력 구성으로 애플리케이션 개발간 선제적인 위험관리와 제품의 품질 확보를 위해 노력합니다.</p>
							</div>
						</li>

						{/* <!-- Item 03 --> */}
						<li>
							<img src={busi07} alt="Operate" />

							<div className="textBox">
								<h4 className="title"><span className="num">03</span> Operate</h4>
								<p className="text">애플리케이션의 지속적인 개선을 목표로 시스템 운영간 안정성과 신뢰성을 제공합니다.</p>
							</div>
						</li>

						{/* <!-- Item 04 --> */}
						<li>

							<img src={busi08} alt="Maintenance" />
							<div className="textBox">
								<h4 className="title"><span className="num">04</span> Maintenance</h4>
								<p className="text">시스템 결함 및 고객의 요구사항에 대해 즉각적인 대응체계를 통해 통합 품질관리를 실천하고 있습니다.</p>
							</div>
						</li>

					</ul>
			</section>

     <CallWipia />
		</main>
	<Footer />
    </>    
    )
}

export default BusinessArea;